import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import {useFetching} from "../hooks/useFetching";
import OrderRAPI from "../API/OrderRAPI";
import {OrderItemServiceType, OrderItemType, OrderType} from "../models/OrderModels";

interface ProcessedService extends OrderItemServiceType {
    label: string;
}

interface ProcessedItem {
    type: string;
    material: string;
    color: string;
    wear: string;
    services: ProcessedService[];
}

const ReceiptPage: React.FC = () => {
    let {id} = useParams();

    const [order, setOrder] = useState<OrderType>();
    const [processedItems, setProcessedItems] = useState<ProcessedItem[]>([]);
    const [hasS1, setHasS1] = useState(false);
    const [hasS2, setHasS2] = useState(false);
    const [hasS3, setHasS3] = useState(false);

    const [fetchData, isLoading, errorData] = useFetching(async () => {
        const res = await OrderRAPI.getById(Number(id));
        setOrder(res);

        let hasS1Flag = false;
        let hasS2Flag = false;
        let hasS3Flag = false;

        const processed: ProcessedItem[] = [];

        if (res.items) {
            res.items.forEach((item: OrderItemType) => {
                const itemServices: ProcessedService[] = [];

                item.services.forEach((service: OrderItemServiceType) => {
                    if (Number(service.status) === 2) return;

                    let label = service.label;

                    if (label.substr(0, 3) === 'ХЧ ') {
                        label = '* Химчистка' + label.substr(3);
                    } else if (label.substr(0, 3) === 'КЧ ') {
                        label = '** Комплексная чистка' + label.substr(3);
                    }

                    if (label.indexOf('Классическая чистка') !== -1) {
                        label = label.replace('Классическая чистка', '* Классическая чистка');
                        hasS1Flag = true;
                    } else if (label.indexOf('Комплексная чистка') !== -1) {
                        label = label.replace('Комплексная чистка', '** Комплексная чистка');
                        hasS2Flag = true;
                    } else if (label.indexOf('Биочистка') !== -1) {
                        label = label.replace('Биочистка', '*** Биочистка');
                        hasS3Flag = true;
                    }

                    itemServices.push({...service, label});
                });

                if (itemServices.length > 0) {
                    processed.push({
                        type: item.type,
                        material: item.material,
                        color: item.color,
                        wear: item.wear || '',
                        services: itemServices
                    });
                }
            });
        }

        setProcessedItems(processed);
        setHasS1(hasS1Flag);
        setHasS2(hasS2Flag);
        setHasS3(hasS3Flag);
    });

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (!isLoading && order) {
            const timeout = setTimeout(() => {
                window.print();
            }, 500);
            return () => clearTimeout(timeout);
        }
    }, [isLoading, order]);

    function getGaranteeString(group: string, code: string): string {
        let gar = 'Без гарантии';
        if (group === 's1' || group === 's99' || group === 's119') {
            gar = 'Без гарантии';
            if (['s17', 's21', 's22', 's23', 's24', 's19', 's161', 's20', 's104', 's124', 's125', 's126'].includes(code)) {
                gar = 'Гарантия 30 дней';
            }
        } else if (group === 's25') {
            gar = 'Гарантия 20 дней';
        }
        return gar;
    }

    function formatPhone(phone: number): string {
        const str = phone.toString();
        return `+7 (${str.substr(0, 3)}) ${str.substr(3, 3)}-${str.substr(6, 2)}-${str.substr(8, 2)}`;
    }

    function nf(num: number): string {
        return Intl.NumberFormat('ru').format(num) + ' руб.';
    }

    function formatDate(dateStr: string): string {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        return date.toLocaleDateString('ru');
    }

    if (isLoading || !order) {
        return <div className="container mt-5"><p>Загрузка...</p></div>;
    }

    let summ = 0;
    processedItems.forEach(item => {
        item.services.forEach(service => {
            summ += Number(service.price);
        });
    });

    return (
        <div className="containesr">
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500&display=swap');
                
                * {
                    box-sizing: border-box;
                }
                body {
                    font-family: 'Roboto', sans-serif;
                    font-size: 16px;
                    line-height: 1.3;
                    color: #000;
                    margin: 0;
                    padding: 20px;
                }
                .cb { clear: both; }
                .tac { text-align: center; width: 100%; }
                .ff { font-family: 'Roboto', sans-serif; }
                .fb { font-weight: 600; }
                .fn { font-weight: normal; }
                .h1 { 
                    margin: 0; 
                    font-weight: 500; 
                    font-size: 26px; 
                    text-transform: none; 
                }
                .df { display: flex; float: right; }
                
                .line { display: flex; margin: 2px 0; }
                .line div { width: 50%; }
                .linewu { display: flex; margin: 0px 0; }
                .linewu .l50 { width: 50%; }
                .ul { width: fit-content; }
                .m8 { margin: 8px 0 6px; font-weight: bold; }
                
                table {
                    border-collapse: collapse;
                    width: 100%;
                    text-align: center;
                }
                th, td {
                    border: 1px solid #000;
                    padding: 5px;
                }
                th { background: #ddd; }
                
                .fs16 { font-size: 16px; }
                .fs14 { font-size: 14px; }
                .item_odd_0 { background: #eee; }
                .item_odd_1 { background: #fff; }
                
                .recblock {
                    border: 2px solid;
                    padding: 8px;
                    font-size: 14px;
                }
                .bank_info { margin: 8px 0px; }
                
                .col-md-3 { width: 30%; float: left; }
                .col-md-5 { width: 40%; float: left; }
                .col-md-6 { width: 50%; float: left; }
                .col-md-12 { width: 100%; float: left; }
                
                .prilo { margin-top: 20px; }
                .prilo p { margin: 4px 0; }
                
                @media print {
                    body { min-width: 992px !important; }
                    .container { min-width: 992px !important; }
                }
            `}</style>

            <div className="row cb" style={{marginBottom: '0px'}}>
                <div className="col-md-3">
                    <div className="h1 ff fb" style={{marginTop: '0px', fontSize: '22px'}}>
                        <img src="/assets/img/logos.png" height="50" alt="logo"/>
                        Наряд-заказ № {order.id}
                    </div>
                </div>
                <div className="col-md-5 tac" style={{marginTop: '0px'}}>
                    <div className="ff fb" style={{fontSize: '16px', margin: '0 auto', width: 'fit-content'}}>
                        ИП Бикмухаметов Рустам Ринатович
                        <br/>ОГРНИП 319169000073117, ИНН 165603731307
                        <br/>420030, ул. Большая 106, а/я 4
                    </div>
                </div>
                <div className="col-md-3" style={{textAlign: 'right'}}>
                    <div style={{marginTop: '0px', fontWeight: 'bold', lineHeight: '18px', fontSize: '16px'}}>
                        г. Казань,
                        <br/>ул. Чернышевского, д. 35
                        <br/>☎ 239-25-48 📱 zrservice
                        <br/>🌐 www.zrgroup.ru
                    </div>
                </div>
            </div>

            <div className="cb" style={{margin: '20px 0'}}>
                <div className="col-md-5" style={{maxWidth: '45%'}}>
                    <div className="linewu">
                        Заказчик:&nbsp;
                        <div className="ul">
                            {order.client?.last_name} {order.client?.name} {order.client?.second_name}
                        </div>
                    </div>
                </div>
                <div className="col-md-5" style={{maxWidth: '55%', float: 'right'}}>
                    <div className="df">
                        Дата приема:&nbsp;
                        <div className="ul">{formatDate(order.createdAt)}</div>
                    </div>
                </div>
                <div className="col-md-5" style={{maxWidth: '45%', clear: 'both'}}>
                    <div className="linewu">
                        Телефон:&nbsp;
                        <div className="ul">{order.client?.phone ? formatPhone(order.client.phone) : ''}</div>
                    </div>
                </div>
                <div className="col-md-5" style={{maxWidth: '55%', float: 'right'}}>
                    <div className="df">
                        Планируемая дата выдачи:&nbsp;
                        <div className="ul">{formatDate(order.desiredAt)}</div>
                    </div>
                </div>
                {order.client?.discount != 0 && (
                    <div className="col-md-5" style={{maxWidth: '45%'}}>
                        <div className="linewu">
                            Персональная скидка:&nbsp;
                            <div className="ul">{order.client?.discount}%</div>
                        </div>
                    </div>
                )}
            </div>

            <div className="col-md-12">
                <table>
                    <thead>
                        <tr style={{background: '#ddd'}}>
                            <th>№</th>
                            <th>Изделие</th>
                            <th>Износ</th>
                            <th style={{width: '40%'}}>Перечень работ</th>
                            <th>Сумма</th>
                        </tr>
                    </thead>
                    <tbody>
                        {processedItems.map((item, itemIndex) => (
                            item.services.map((service, serviceIndex) => (
                                <tr key={`${itemIndex}-${serviceIndex}`} className={`item_odd_${(itemIndex + 1) % 2}`}>
                                    {serviceIndex === 0 && (
                                        <>
                                            <td rowSpan={item.services.length}>{itemIndex + 1}</td>
                                            <td rowSpan={item.services.length}>{item.type} {item.material} {item.color}</td>
                                            <td rowSpan={item.services.length}>{item.wear}</td>
                                        </>
                                    )}
                                    <td style={{textAlign: 'left'}}>
                                        {service.label}
                                        <br/>
                                        <span className="fs14">{getGaranteeString(service.group || '', service.code || '')}</span>
                                    </td>
                                    <td>{Number(service.price)}</td>
                                </tr>
                            ))
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="col-md-6" style={{marginTop: '20px'}}>
                {order.discount != 0 && (
                    <>
                        <div className="linewu">
                            Общая стоимость (без скидки):&nbsp;
                            <div className="ul">{nf(summ)}</div>
                        </div>
                        {order.discount > 0 && (
                            <div className="linewu">
                                Скидка на заказ:&nbsp;
                                <div className="ul">{order.discount}%</div>
                            </div>
                        )}
                        {order.discount < 0 && (
                            <div className="linewu">
                                Наценка за срочность:&nbsp;
                                <div className="ul">{Math.abs(order.discount)}%</div>
                            </div>
                        )}
                    </>
                )}
                <div className="linewu">
                    Итого к оплате:&nbsp;
                    <div className="ul">{nf(Number(order.totalSum))}</div>
                </div>
                <div className="linewu">
                    Внесенный аванс:&nbsp;
                    <div className="ul">{nf(Number(order.payedSum))}</div>
                </div>
                <div className="linewu">
                    Остаток:&nbsp;
                    <div className="ul">{nf(Number(order.totalSum) - Number(order.payedSum))}</div>
                </div>
            </div>

            <div className="col-md-6 prilo fs16">
                {hasS1 && (
                    <p>* Классическая чистка:
                        <br/>- обработка обуви в антибактериальной камере
                        <br/>- чистка верха обуви из гладкой кожи (без удаления глубоких загрязнений)
                        <br/>- сухая внутренняя чистка (продувка и чистка налипшего мусора)
                        <br/>- чистка рантов (без покраса)
                        <br/>- мойка подошвы (без очистки сложных загрязнений)
                        <br/>- кондиционирование кожи
                        <br/>- нанесение крема
                        <br/>- полировка
                    </p>
                )}
                {hasS2 && (
                    <p>** Комплексная чистка:
                        <br/>- обработка обуви в антибактериальной камере
                        <br/>- глубокая чистка поверхности изделия (удаление загрязнений, пятен и разводов без использования агрессивных химических средств)
                        <br/>- влажная внутренняя чистка
                        <br/>- стирка/замена шнурков
                        <br/>- чистка рантов с пропиткой
                        <br/>- мойка подошвы (с очисткой загрязнений без использования агрессивных химических средств)
                        <br/>- кондиционирование кожи
                        <br/>- восстановление цвета
                        <br/>- полировка/восстановление бархотистости замши
                        <br/>- обработка водоотталкивающим средством
                    </p>
                )}
                {hasS3 && (
                    <p>*** Биочистка:
                        <br/>- обработка обуви в антибактериальной камере
                        <br/>- влажная деликатная чистка с использованием нейтральной биоразлагаемой химии;
                        <br/>- влажная внутренняя чистка
                        <br/>- стирка шнурков
                        <br/>- кондиционирование материала
                        <br/>- обработка водоотталкивающим средством
                    </p>
                )}
            </div>
        </div>
    );
};

export default ReceiptPage;